<template>
<v-dialog max-width="500" persistent v-model="dialog" scrollable>
    <v-card>
    <v-toolbar dark>
        <v-toolbar-title class="headline">Add credit</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-icon @click="$emit('setDialog', false)">close</v-icon>
    </v-toolbar>

    <v-card-text style="height: auto;">
        <v-form ref="form" v-model="valid" lazy-validation>
            <v-layout row wrap>
                <v-flex xs12 sm12 class="pa-1">
                    <v-card class="pa-2">
                        <!-- โชว์เฉพาะไรเดอร์ที่active -->
                        <v-select :items="rider_name_item" label="Rider name"></v-select>
                        <v-layout row wrap class="text-xs-center">
                            <v-flex xs6>
                                <span class="style-title-detail">Cash : </span><span class="style-data-detail">1000.00 ฿</span>
                            </v-flex>
                            <v-flex xs6>
                                <span class="style-title-detail">Credit : </span><span class="style-data-detail">100</span>
                            </v-flex>
                        </v-layout>
                    </v-card>
                    <v-text-field label="Amount credit" hide-details></v-text-field>
                    <v-textarea label="Note :" rows="3" hide-details></v-textarea>
                </v-flex>
            </v-layout>
        </v-form>
    </v-card-text>

    <v-card-actions>
        <v-spacer/>
        <v-btn color="primary" class="black--text" @click="$emit('setDialog', false)">add</v-btn>
        <v-spacer/>
    </v-card-actions>
    </v-card>
</v-dialog>
</template>

<script>
export default {
    props: ["dialog"],
    data() {
        return {
            valid: true,
            rider_name_item: ['คุณไก่ผัดมะม่วง','คุณหมูหัน']
        }
    }
}
</script>

<style scoped>
.style-title-detail {
  font-size: 15px;
  margin-bottom: 10px;
}

.style-data-detail {
  font-size: 15px;
  color: #616a6b;
}
</style>




